module.exports = __webpack_public_path__ + "static/media/LogoArtlingProjectsWhiteBeta.14413aa0.svg";